"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4651,1319,564],{

/***/ 220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ bottomMenu; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/api/constants.js
var constants = __webpack_require__(9041);
// EXTERNAL MODULE: ./src/components/homePage/goodMorning/ftafatModal/index.js
var ftafatModal = __webpack_require__(29778);
// EXTERNAL MODULE: ./src/api/commonConstants.js
var commonConstants = __webpack_require__(96781);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/constants/cricket.js
var cricket = __webpack_require__(34044);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(2185);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/cricket/ipl/BottomStripIPL.js









var BottomStripIPL = function BottomStripIPL(_ref) {
  var setShowLiveAtBottom = _ref.setShowLiveAtBottom;
  var scoreData = (0,es/* useSelector */.v9)(function (state) {
    return state.SeriesReducer.scoreData;
  });

  var filterBySeries = function filterBySeries(allMatches) {
    return allMatches.filter(function (match) {
      return match.series_Id == cricket/* SERIES_ID_IPL */.YF;
    });
  };

  var sortByDate = function sortByDate(matches) {
    return matches.sort(function (a, b) {
      return new Date(a.matchdate_ist) - new Date(b.matchdate_ist);
    });
  };

  var _useState = (0,react.useState)(null),
      liveId = _useState[0],
      setLiveId = _useState[1];

  var _useState2 = (0,react.useState)(null),
      liveData = _useState2[0],
      setLiveData = _useState2[1];

  (0,react.useEffect)(function () {
    var _scoreData$live, _scoreData$live$chann, _scoreData$live$chann2, _scoreData$live2, _scoreData$live2$chan;

    // const live = false
    //match is live
    if (scoreData !== null && scoreData !== void 0 && scoreData.live && (scoreData === null || scoreData === void 0 ? void 0 : (_scoreData$live = scoreData.live) === null || _scoreData$live === void 0 ? void 0 : (_scoreData$live$chann = _scoreData$live.channel) === null || _scoreData$live$chann === void 0 ? void 0 : (_scoreData$live$chann2 = _scoreData$live$chann.live) === null || _scoreData$live$chann2 === void 0 ? void 0 : _scoreData$live$chann2.length) > 0 && filterBySeries(scoreData === null || scoreData === void 0 ? void 0 : (_scoreData$live2 = scoreData.live) === null || _scoreData$live2 === void 0 ? void 0 : (_scoreData$live2$chan = _scoreData$live2.channel) === null || _scoreData$live2$chan === void 0 ? void 0 : _scoreData$live2$chan.live).length > 0) {
      var _scoreData$live3, _scoreData$live3$chan, _data$, _data$2, _data$3, _data$4, _data$5, _data$6, _data$7, _data$8, _data$9, _data$10, _data$11, _data$12, _data$13, _data$14, _data$15, _data$16, _data$17, _data$18, _data$19, _data$20, _data$21, _data$22, _data$23;

      var data = sortByDate(filterBySeries(scoreData === null || scoreData === void 0 ? void 0 : (_scoreData$live3 = scoreData.live) === null || _scoreData$live3 === void 0 ? void 0 : (_scoreData$live3$chan = _scoreData$live3.channel) === null || _scoreData$live3$chan === void 0 ? void 0 : _scoreData$live3$chan.live)); // setMatchData(data[0]);

      setLiveId((_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.match_Id);
      setShowLiveAtBottom(true);
      setLiveData({
        seriesName: (_data$2 = data[0]) === null || _data$2 === void 0 ? void 0 : _data$2.series_name,
        matchId: (_data$3 = data[0]) === null || _data$3 === void 0 ? void 0 : _data$3.match_Id,
        matchNumber: (_data$4 = data[0]) === null || _data$4 === void 0 ? void 0 : _data$4.matchnumber,
        teamAId: (_data$5 = data[0]) === null || _data$5 === void 0 ? void 0 : _data$5.teama_Id,
        teamBId: (_data$6 = data[0]) === null || _data$6 === void 0 ? void 0 : _data$6.teamb_Id,
        whoIsBowling: (_data$7 = data[0]) === null || _data$7 === void 0 ? void 0 : _data$7.inn_team_1,
        whoIsBatting: (_data$8 = data[0]) === null || _data$8 === void 0 ? void 0 : _data$8.inn_team_2,
        bowlingTeamScore: (_data$9 = data[0]) === null || _data$9 === void 0 ? void 0 : _data$9.inn_score_1,
        battingTeamScore: (_data$10 = data[0]) === null || _data$10 === void 0 ? void 0 : _data$10.inn_score_2,
        teamALogo: (_data$11 = data[0]) === null || _data$11 === void 0 ? void 0 : _data$11.teama_flag,
        teamBLogo: (_data$12 = data[0]) === null || _data$12 === void 0 ? void 0 : _data$12.teamb_flag,
        teamAShort: (_data$13 = data[0]) === null || _data$13 === void 0 ? void 0 : _data$13.teama_short,
        teamBShort: (_data$14 = data[0]) === null || _data$14 === void 0 ? void 0 : _data$14.teamb_short,
        teamAName: (_data$15 = data[0]) === null || _data$15 === void 0 ? void 0 : _data$15.teama_hn,
        teamBName: (_data$16 = data[0]) === null || _data$16 === void 0 ? void 0 : _data$16.teamb_hn,
        matchStatus: (_data$17 = data[0]) === null || _data$17 === void 0 ? void 0 : _data$17.matchresult,
        matchResult: (_data$18 = data[0]) === null || _data$18 === void 0 ? void 0 : _data$18.matchstatus,
        pageSlugSt: (_data$19 = data[0]) === null || _data$19 === void 0 ? void 0 : _data$19.page_slug_st,
        showStar: ((_data$20 = data[0]) === null || _data$20 === void 0 ? void 0 : _data$20.inn_team_1) == ((_data$21 = data[0]) === null || _data$21 === void 0 ? void 0 : _data$21.teama_Id) ? (_data$22 = data[0]) === null || _data$22 === void 0 ? void 0 : _data$22.teama_Id : (_data$23 = data[0]) === null || _data$23 === void 0 ? void 0 : _data$23.teamb_Id
      });
    } else {
      setLiveId(null);
      setShowLiveAtBottom(false);
      setLiveData(null);
    }
  }, [scoreData]);
  (0,react.useEffect)(function () {
    if (liveId) {
      var poolingLiveMatches = /*#__PURE__*/function () {
        var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
          var _response$data, _fetchedData$data, _fetchedData$data$res, _fetchedData$data$res2, _fetchedData$data$res3;

          var response, fetchedData, _fetchedData$data2, _fetchedData$data2$re, data;

          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return axios_default().get("".concat("https://www.thelallantop.com", "/api/getRecentMatch?id=").concat(liveId, "&nocache=").concat(new Date().getTime()));

                case 2:
                  response = _context.sent;
                  fetchedData = (_response$data = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data !== void 0 ? _response$data : null;

                  if ((fetchedData === null || fetchedData === void 0 ? void 0 : (_fetchedData$data = fetchedData.data) === null || _fetchedData$data === void 0 ? void 0 : (_fetchedData$data$res = _fetchedData$data.response) === null || _fetchedData$data$res === void 0 ? void 0 : (_fetchedData$data$res2 = _fetchedData$data$res.scorecard) === null || _fetchedData$data$res2 === void 0 ? void 0 : (_fetchedData$data$res3 = _fetchedData$data$res2.match_Id) === null || _fetchedData$data$res3 === void 0 ? void 0 : _fetchedData$data$res3.length) > 0) {
                    // // setLiveData(fetchedData?.data?.response?.scorecard);
                    // //update the array of carousel
                    // setCarouselMatches(carouselMatches?.map(it => {
                    //   if(it.channel.scorecard.match_Id == fetchedData?.data?.response?.scorecard?.match_Id){
                    //     return item.channel.scorecard
                    //   }
                    //   else{
                    //     return it
                    //   }
                    // }))
                    data = fetchedData === null || fetchedData === void 0 ? void 0 : (_fetchedData$data2 = fetchedData.data) === null || _fetchedData$data2 === void 0 ? void 0 : (_fetchedData$data2$re = _fetchedData$data2.response) === null || _fetchedData$data2$re === void 0 ? void 0 : _fetchedData$data2$re.scorecard; //set the match data of the live match
                    //   setMatchData(data);

                    setLiveData({
                      seriesName: data === null || data === void 0 ? void 0 : data.seriesname,
                      matchId: data === null || data === void 0 ? void 0 : data.match_Id,
                      matchNumber: data === null || data === void 0 ? void 0 : data.matchnumber,
                      teamAId: data === null || data === void 0 ? void 0 : data.teama_Id,
                      teamBId: data === null || data === void 0 ? void 0 : data.teamb_Id,
                      whoIsBowling: data === null || data === void 0 ? void 0 : data.current_bowling_team_id,
                      whoIsBatting: data === null || data === void 0 ? void 0 : data.current_batting_team,
                      bowlingTeamScore: data === null || data === void 0 ? void 0 : data.bowlingTeamStats,
                      battingTeamScore: data === null || data === void 0 ? void 0 : data.battingTeamStats,
                      teamALogo: data === null || data === void 0 ? void 0 : data.teama_logo,
                      teamBLogo: data === null || data === void 0 ? void 0 : data.teamb_logo,
                      teamAName: data === null || data === void 0 ? void 0 : data.teama_hn,
                      teamBName: data === null || data === void 0 ? void 0 : data.teamb_hn,
                      teamAShort: data === null || data === void 0 ? void 0 : data.teama_short,
                      teamBShort: data === null || data === void 0 ? void 0 : data.teamb_short,
                      matchStatus: data === null || data === void 0 ? void 0 : data.matchresult_hn,
                      matchResult: data === null || data === void 0 ? void 0 : data.matchStatus_hn,
                      pageSlugSt: data === null || data === void 0 ? void 0 : data.page_slug_st,
                      showStar: (data === null || data === void 0 ? void 0 : data.current_bowling_team_id) == (data === null || data === void 0 ? void 0 : data.teama_Id) ? data === null || data === void 0 ? void 0 : data.teamb_Id : data === null || data === void 0 ? void 0 : data.teama_Id
                    });
                  } else {// alert("Please refresh the page.");
                    // Refresh the page after user clicks OK
                    // window.location.reload();
                  }

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function poolingLiveMatches() {
          return _ref2.apply(this, arguments);
        };
      }();

      var interval = setInterval(function () {
        poolingLiveMatches();
      }, 3000);
      return function () {
        return clearInterval(interval);
      };
    }
  }, [liveId]);

  function splitString(input) {
    var index = input.indexOf('(');
    if (index === -1) return [input, '']; // If '(' is not found

    var before = input.substring(0, index).trim();
    var after = input.substring(index).trim();
    return [before, after];
  }

  var onCardClick = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(matchId) {
      var _response$data2, _fetchedData$data3, _fetchedData$data3$re, _fetchedData$data3$re2, _fetchedData$data3$re3;

      var response, fetchedData, _fetchedData$data4, _fetchedData$data4$re, data, page;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return axios_default().get("".concat("https://www.thelallantop.com", "/api/getRecentMatch?id=").concat(matchId, "&nocache=").concat(new Date().getTime()));

            case 2:
              response = _context2.sent;
              fetchedData = (_response$data2 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data2 !== void 0 ? _response$data2 : null;

              if ((fetchedData === null || fetchedData === void 0 ? void 0 : (_fetchedData$data3 = fetchedData.data) === null || _fetchedData$data3 === void 0 ? void 0 : (_fetchedData$data3$re = _fetchedData$data3.response) === null || _fetchedData$data3$re === void 0 ? void 0 : (_fetchedData$data3$re2 = _fetchedData$data3$re.scorecard) === null || _fetchedData$data3$re2 === void 0 ? void 0 : (_fetchedData$data3$re3 = _fetchedData$data3$re2.match_Id) === null || _fetchedData$data3$re3 === void 0 ? void 0 : _fetchedData$data3$re3.length) > 0) {
                data = fetchedData === null || fetchedData === void 0 ? void 0 : (_fetchedData$data4 = fetchedData.data) === null || _fetchedData$data4 === void 0 ? void 0 : (_fetchedData$data4$re = _fetchedData$data4.response) === null || _fetchedData$data4$re === void 0 ? void 0 : _fetchedData$data4$re.scorecard;
                page = null;

                if (data.is_live == 1) {
                  page = 'live';
                } else if (data.upcoming == 1) {
                  page = 'info';
                } else {
                  page = 'summary';
                }

                window.location.href = "/sports/ipl/".concat(data === null || data === void 0 ? void 0 : data.page_slug_st, "/stats/").concat(page);
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onCardClick(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return liveId && liveData ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: "IPL_STRIP",
    className: "row w-100 my-3",
    style: {
      height: "73px",
      backgroundImage: "url(/assets/images/ipl_microsite/ipl_banner.jpg)",
      backgroundSize: "cover",
      backgroundPosition: "center"
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "row align-items-center p-0 m-0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-8",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "d-flex justify-content-between align-items-center w-100",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "d-flex align-items-center gap-2",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                width: "30px",
                height: "30px"
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                alt: "Team_Logo",
                src: cricket/* TEAMS_OBJ */.iu[liveData === null || liveData === void 0 ? void 0 : liveData.teamAShort] ? cricket/* TEAMS_OBJ */.iu[liveData === null || liveData === void 0 ? void 0 : liveData.teamAShort] : liveData === null || liveData === void 0 ? void 0 : liveData.teamALogo,
                style: {
                  width: "100%",
                  height: "100%"
                },
                className: "w-100 h-100"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: "m-0 p-0 text-white",
                style: {
                  fontSize: "14px",
                  fontWeight: 700
                },
                children: [(liveData === null || liveData === void 0 ? void 0 : liveData.teamAId) == (liveData === null || liveData === void 0 ? void 0 : liveData.whoIsBowling) ? splitString(liveData === null || liveData === void 0 ? void 0 : liveData.bowlingTeamScore)[0] : splitString(liveData === null || liveData === void 0 ? void 0 : liveData.battingTeamScore)[0], " ", (liveData === null || liveData === void 0 ? void 0 : liveData.showStar) == (liveData === null || liveData === void 0 ? void 0 : liveData.teamAId) && " *"]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: "m-0 p-0 text-white",
                style: {
                  fontSize: "10px",
                  fontWeight: 400
                },
                children: [(liveData === null || liveData === void 0 ? void 0 : liveData.teamAId) == (liveData === null || liveData === void 0 ? void 0 : liveData.whoIsBowling) ? splitString(liveData === null || liveData === void 0 ? void 0 : liveData.bowlingTeamScore)[1] : splitString(liveData === null || liveData === void 0 ? void 0 : liveData.battingTeamScore)[1], " "]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "m-0 p-0",
            style: {
              fontWeight: 400,
              fontSize: "13px",
              color: "rgba(255, 255, 255, 0.5)"
            },
            children: "v/s"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "d-flex align-items-center gap-2",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: "m-0 p-0 text-white",
                style: {
                  fontSize: "14px",
                  fontWeight: 700
                },
                children: [(liveData === null || liveData === void 0 ? void 0 : liveData.teamBId) == (liveData === null || liveData === void 0 ? void 0 : liveData.whoIsBowling) ? splitString(liveData === null || liveData === void 0 ? void 0 : liveData.bowlingTeamScore)[0] : splitString(liveData === null || liveData === void 0 ? void 0 : liveData.battingTeamScore)[0], " ", (liveData === null || liveData === void 0 ? void 0 : liveData.showStar) == (liveData === null || liveData === void 0 ? void 0 : liveData.teamBId) && " *"]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: "m-0 p-0 text-white",
                style: {
                  fontSize: "10px",
                  fontWeight: 400
                },
                children: [(liveData === null || liveData === void 0 ? void 0 : liveData.teamBId) == (liveData === null || liveData === void 0 ? void 0 : liveData.whoIsBowling) ? splitString(liveData === null || liveData === void 0 ? void 0 : liveData.bowlingTeamScore)[1] : splitString(liveData === null || liveData === void 0 ? void 0 : liveData.battingTeamScore)[1], " "]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                width: "30px",
                height: "30px"
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                alt: "Team_Logo",
                src: cricket/* TEAMS_OBJ */.iu[liveData === null || liveData === void 0 ? void 0 : liveData.teamBShort] ? cricket/* TEAMS_OBJ */.iu[liveData === null || liveData === void 0 ? void 0 : liveData.teamBShort] : liveData === null || liveData === void 0 ? void 0 : liveData.teamBLogo,
                style: {
                  width: "100%",
                  height: "100%"
                },
                className: "w-100 h-100"
              })
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-4 h-100  d-flex align-items-center justify-content-center",
        style: {
          clipPath: "polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%)",
          backgroundColor: "rgba(235, 14, 140, 1)"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          onClick: function onClick() {
            onCardClick(liveData === null || liveData === void 0 ? void 0 : liveData.matchId);
          },
          className: "d-flex gap-2 align-items-center",
          style: {
            cursor: "pointer"
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "m-0 p-0 text-white",
            style: {
              fontSize: "10px",
              fontWeight: 400
            },
            children: "Match Center"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
            width: "8",
            height: "11",
            viewBox: "0 0 8 11",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              d: "M2.03516 1.25781L6.21563 5.31966L2.03516 9.80906",
              stroke: "white",
              "stroke-width": "2.13781",
              "stroke-linecap": "round"
            })
          })]
        })
      })]
    })
  }) : null;
};

/* harmony default export */ var ipl_BottomStripIPL = (BottomStripIPL);
;// CONCATENATED MODULE: ./src/components/shared/footer/bottomMenu.js


 // import Link from "next/link";







 // import ClevertapReact from "utils/clevertapHelper";





var MobileMenuBottom = function MobileMenuBottom() {
  var _router$query, _bottomBanner$, _bottomBanner$3;

  var size = (0,commonConstants/* useWindowSize */.iP)();

  var _useState = (0,react.useState)(false),
      isKeyPresent = _useState[0],
      setIsKeyPresent = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isKeyPresentIPL = _useState2[0],
      setIsKeyPresentIPL = _useState2[1];

  var keyToCheck = "RECENGINE"; // The key you want to check

  var keyToCheckIPL = "IPL_STRIP"; // The key you want to check

  var _useSelector = (0,es/* useSelector */.v9)(function (_ref) {
    var SeriesReducer = _ref.SeriesReducer;
    return SeriesReducer;
  }),
      videoIsShow = _useSelector.videoIsShow;

  var router = (0,next_router.useRouter)();

  var _useState3 = (0,react.useState)(router !== null && router !== void 0 && router.pathname.includes("/quiz") ? "quiz" : router !== null && router !== void 0 && router.pathname.includes("/short-video") ? "short-video" : router !== null && router !== void 0 && router.pathname.includes("/text") ? "text" : router !== null && router !== void 0 && router.pathname.includes("/audio") ? "audio" : router !== null && router !== void 0 && router.pathname.includes("/show") ? "show" : "all"),
      activeTab = _useState3[0],
      setActiveTab = _useState3[1];

  var openFatafat = router.query.fatafat;

  var _useState4 = (0,react.useState)([]),
      fatafatPosts = _useState4[0],
      setFatafatPosts = _useState4[1];

  var _useState5 = (0,react.useState)(0),
      scrollY = _useState5[0],
      setScrollY = _useState5[1];

  var _useState6 = (0,react.useState)([]),
      bottomBanner = _useState6[0],
      setBottomBanner = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      closeFooterBanner = _useState7[0],
      setCloseFooterBanner = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      showLiveAtBottom = _useState8[0],
      setShowLiveAtBottom = _useState8[1];

  var _useState9 = (0,react.useState)(typeof openFatafat !== "undefined" && openFatafat === "true" ? true : false),
      shouldShow = _useState9[0],
      setShouldShow = _useState9[1];

  var queryIndex = (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.index ? parseInt(router.query.index) : 0;

  var _useState10 = (0,react.useState)(false),
      firstScroll = _useState10[0],
      setFirstScroll = _useState10[1];

  function callGtag() {// window.googletag = window.googletag || { cmd: [] };
    // window.dataLayer = window.dataLayer || [];
    // function gtag() {
    //   dataLayer.push(arguments);
    // }
    // gtag("js", new Date());
    // gtag("config", "G-RXRPKR4310");
    // (function (w, d, s, l, i) {
    //   w[l] = w[l] || [];
    //   w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    //   var f = d.getElementsByTagName(s)[0],
    //     j = d.createElement(s),
    //     dl = l != "dataLayer" ? "&l=" + l : "";
    //   j.async = true;
    //   j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    //   f.parentNode.insertBefore(j, f);
    // })(window, document, "script", "dataLayer", "GTM-P9LRV6T");
    // const gtag1 = document.createElement("script");
    // gtag1.setAttribute(
    //   "src",
    //   "https://www.googletagmanager.com/gtag/js?id=UA-203175993-6"
    // );
    // gtag1.setAttribute("async", "true");
    // document.head.appendChild(gtag1);
    // const gtag2 = document.createElement("script");
    // gtag2.setAttribute(
    //   "src",
    //   "https://www.googletagmanager.com/gtag/js?id=G-RXRPKR4310"
    // );
    // gtag2.setAttribute("async", "true");
    // document.head.appendChild(gtag2);
  }

  (0,react.useEffect)(function () {
    router !== null && router !== void 0 && router.pathname.includes("/quiz") ? setActiveTab("quiz") : router !== null && router !== void 0 && router.pathname.includes("/short-video") ? "short-video" : router !== null && router !== void 0 && router.pathname.includes("/text") ? setActiveTab("text") : router !== null && router !== void 0 && router.pathname.includes("/audio") ? setActiveTab("audio") : router !== null && router !== void 0 && router.pathname.includes("/show") ? setActiveTab("show") : setActiveTab("all");
  }, [router === null || router === void 0 ? void 0 : router.pathname]);

  var _useState11 = (0,react.useState)(true),
      showFooter = _useState11[0],
      setShowFooter = _useState11[1];

  var _useState12 = (0,react.useState)(null),
      scrollDirection = _useState12[0],
      setScrollDirection = _useState12[1]; // useEffect(()=>{
  //   setTimeout(()=>{
  //     setScrollDirection("up")
  //   },4000);
  // })


  (0,react.useEffect)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _router$pathname, _router$pathname2;

    var data, amp, dat;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!(router !== null && router !== void 0 && (_router$pathname = router.pathname) !== null && _router$pathname !== void 0 && _router$pathname.includes("/post/")) && !(router !== null && router !== void 0 && (_router$pathname2 = router.pathname) !== null && _router$pathname2 !== void 0 && _router$pathname2.includes("/video/")))) {
              _context.next = 9;
              break;
            }

            _context.next = 3;
            return fetch("".concat(constants/* baseUrl */.FH, "/banner/all?source=WEB&category=floating-footer"));

          case 3:
            data = _context.sent;
            _context.next = 6;
            return data.json();

          case 6:
            amp = _context.sent;
            dat = amp === null || amp === void 0 ? void 0 : amp.result;
            setBottomBanner(dat);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [router === null || router === void 0 ? void 0 : router.pathname]);
  (0,react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      var _window;

      // console.log("changing scroll");
      setScrollY((_window = window) === null || _window === void 0 ? void 0 : _window.scrollY);
    }; // Add scroll event listener


    window.addEventListener("scroll", handleScroll); // Clean up the event listener on component unmount

    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  (0,react.useEffect)(function () {
    var lastScrollY = window.pageYOffset;

    var updateScrollDirection = function updateScrollDirection() {
      var scrollY = window.pageYOffset;
      var direction = scrollY > lastScrollY ? "down" : "up";

      if (direction !== scrollDirection && (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
        setScrollDirection(direction);
      }

      lastScrollY = scrollY > 0 ? scrollY : 0;
    };

    window.addEventListener("scroll", updateScrollDirection); // add event listener

    return function () {
      window.removeEventListener("scroll", updateScrollDirection); // clean up
    };
  }, [scrollDirection]);
  (0,react.useEffect)(function () {
    var _router$query2, _router$query2$shortI;

    if (router.pathname.includes("/short-video")) {
      setActiveTab("short-video");
    }

    setShowFooter(router.pathname !== "/login" && router.pathname !== "/vs/header_lt" && router.pathname !== "/adda/schedule" && router.pathname !== "/cricket-page" && router.pathname !== "/preferences" && router.pathname !== "/loading/profile" && !router.pathname.includes("/app-view") && !router.pathname.includes("/liveblog") && !router.pathname.includes("/faq-app") && !router.pathname.includes("/quiz/terms-and-conditions") && !router.pathname.includes("/amp/") && !(router !== null && router !== void 0 && (_router$query2 = router.query) !== null && _router$query2 !== void 0 && (_router$query2$shortI = _router$query2.shortId) !== null && _router$query2$shortI !== void 0 && _router$query2$shortI.length));
  }, [router.pathname]);

  var shortsTabClicked = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var requestOptions;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              requestOptions = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  limit: 1,
                  skip: 1
                })
              };
              _context2.next = 3;
              return fetch("".concat("https://api.thelallantop.com", "/v1/short/list"), requestOptions).then(function (response) {
                return response.json();
              }).then(function (data) {
                var _data$result;

                var result = data === null || data === void 0 ? void 0 : (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.entities;
                console.log("lalala", result);
                window.location.href = "/short-video/".concat(result[0].postSlug); // router.push(`/short-video/${result[0].postSlug}`);
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function shortsTabClicked() {
      return _ref3.apply(this, arguments);
    };
  }(); // console.log("showfootermob", !router?.query?.shortId?.length);
  //Fatafat Logic


  (0,react.useEffect)(function () {
    function handleScroll() {
      setFirstScroll(true);
      window.removeEventListener("scroll", handleScroll);
    }

    window.addEventListener("scroll", handleScroll);
  }, []);

  var handleClick = function handleClick() {
    // pushGoogleTabEvent("homepage_fatafat_open", {});
    setShouldShow(false);
    router.push("/"); // setShow((e) => !e);
  };

  var openHandler = function openHandler() {
    if (fatafatPosts && (fatafatPosts === null || fatafatPosts === void 0 ? void 0 : fatafatPosts.length) > 0) {
      var _fatafatPosts$, _fatafatPosts$2, _fatafatPosts$3;

      setShouldShow(true);
      router.push("?fatafat=".concat((_fatafatPosts$ = fatafatPosts[0]) === null || _fatafatPosts$ === void 0 ? void 0 : _fatafatPosts$.postSlug, "&index=0"), "/".concat((_fatafatPosts$2 = fatafatPosts[0]) === null || _fatafatPosts$2 === void 0 ? void 0 : _fatafatPosts$2.categorySlug, "/post/").concat((_fatafatPosts$3 = fatafatPosts[0]) === null || _fatafatPosts$3 === void 0 ? void 0 : _fatafatPosts$3.postSlug), {
        shallow: true
      });
    } else {
      fatafatHandler();
      setShouldShow(true);
    }
  };

  (0,react.useEffect)(function () {
    console.log(router === null || router === void 0 ? void 0 : router.pathname);
  }, []);

  var fatafatHandler = function fatafatHandler() {
    fetch("".concat(constants/* baseUrl */.FH, "/post/allFatafat?limit=9&skip=1&type=text")).then(function (res) {
      return res.json();
    }).then(function (d) {
      var _d$result;

      setFatafatPosts(d === null || d === void 0 ? void 0 : (_d$result = d.result) === null || _d$result === void 0 ? void 0 : _d$result.entities);
    });
  };

  (0,react.useEffect)(function () {
    if (shouldShow) {
      openHandler();
    }
  }, []);
  (0,react.useEffect)(function () {
    // Check if the key exists in the window object
    if (keyToCheck in window) {
      setIsKeyPresent(true);
    } else {
      setIsKeyPresent(false);
    }
  }, [scrollDirection]);
  (0,react.useEffect)(function () {
    if (videoIsShow) {
      setActiveTab('show');
    }
  }, [videoIsShow]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [showFooter && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [scrollY > 170 && (bottomBanner === null || bottomBanner === void 0 ? void 0 : bottomBanner.length) > 0 && !closeFooterBanner && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [(size === null || size === void 0 ? void 0 : size.width) <= 768 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "close-bottom-menu",
          onClick: function onClick(event) {
            event.stopPropagation();
            setCloseFooterBanner(true);
            console.log("erman");
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "X"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: (_bottomBanner$ = bottomBanner[0]) === null || _bottomBanner$ === void 0 ? void 0 : _bottomBanner$.deepLink,
          onClick: function onClick() {
            var _bottomBanner$2;

            ga("create", "G-RXRPKR4310", "auto");
            ga("send", "event", {
              eventCategory: "banner",
              eventAction: "Click",
              eventLabel: "Footer-banner",
              eventValue: "".concat((_bottomBanner$2 = bottomBanner[0]) === null || _bottomBanner$2 === void 0 ? void 0 : _bottomBanner$2.title)
            });
          },
          x: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            className: "bottom-menu bottom-menu-banner",
            src: (_bottomBanner$3 = bottomBanner[0]) === null || _bottomBanner$3 === void 0 ? void 0 : _bottomBanner$3.bannerImage
          })
        })]
      }), !showLiveAtBottom && !router.pathname.includes("/audio") && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "bottom-menu ".concat(scrollDirection === "down" ? "FooterShow" : "FooterAdHide") // style={{ bottom: "60px" }}
        ,
        style: {
          bottom: scrollDirection !== "down" ? "77px" : isKeyPresent ? "123px" : "26px"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container-row py-2",
          align: "center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              textAlign: "center",
              marginBottom: "0rem"
            },
            className: "bg-white",
            children: "Advertisement"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            id: "div-gpt-ad-1701946324333-0",
            style: {
              minWidth: "300px",
              minHeight: "60px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            className: "bg-white",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946324333-0')})"
              }
            })
          })]
        })
      }), (router.pathname.includes("/ipl") || router.pathname === "/") && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [showLiveAtBottom && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bottom-menu ".concat(scrollDirection === "down" ? "FooterShow" : "FooterAdHide") // style={{bottom: "60px" }}
          ,
          style: {
            bottom: scrollDirection !== "down" ? "83px" : isKeyPresent ? "123px" : "101px"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "container-row py-2",
            align: "center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              style: {
                fontSize: "11px",
                color: "#b7b7b7",
                textAlign: "center",
                marginBottom: "0rem"
              },
              className: "bg-white",
              children: "Advertisement"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              id: "div-gpt-ad-1701946324333-0",
              style: {
                minWidth: "300px",
                minHeight: "60px",
                display: "block !important",
                alignContent: "center",
                textAlign: "-webkit-center"
              },
              className: "bg-white",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                  __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946324333-0')})"
                }
              })
            })]
          })
        }), scrollDirection === "down" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bottom-menu ".concat(scrollDirection === "down" ? "FooterShow" : "FooterAdHide") // style={{bottom: "60px" }}
          ,
          style: {
            bottom: scrollDirection !== "down" ? "85px" : isKeyPresent ? "114px" : "30px",
            background: "transparent",
            left: "10px"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ipl_BottomStripIPL, {
            setShowLiveAtBottom: setShowLiveAtBottom
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "bottom-menu ".concat(scrollDirection === "down" ? router.pathname.includes("/audio") ? "" : "FooterHide" : "FooterShow"),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: activeTab === "all" && !shouldShow ? "active" : "",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              href: "/",
              onClick: function onClick() {
                if (typeof window.ga !== "undefined") {
                  ga("create", "G-RXRPKR4310", "auto");
                  ga("send", "event", {
                    eventCategory: "bottom_menu",
                    eventAction: "Click",
                    eventLabel: "home",
                    eventValue: "https://www.thelallantop.com/"
                  });
                }

                setActiveTab("all");
              },
              children: [activeTab === "all" && !shouldShow ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "icon-home icon-padding",
                src: "https://static.thelallantop.com/images/post/1742895514831_home-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "icon-home icon-padding",
                src: "https://static.thelallantop.com/images/post/1742894786610_home-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "home",
                  defaultMessage: "\u0939\u094B\u092E"
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: activeTab === "show" && !shouldShow ? "active" : "",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              href: "/show/all",
              onClick: function onClick() {
                if (typeof window.ga !== "undefined") {
                  ga("create", "G-RXRPKR4310", "auto");
                  ga("send", "event", {
                    eventCategory: "bottom_menu",
                    eventAction: "Click",
                    eventLabel: "shows",
                    eventValue: "https://www.thelallantop.com/show/all"
                  });
                }

                setActiveTab("show");
              },
              children: [activeTab === "show" && !shouldShow ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "icon-shows icon-padding",
                src: "https://static.thelallantop.com/images/post/1742895590628_video-play-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "icon-shows icon-padding",
                src: "https://static.thelallantop.com/images/post/1742894865346_video-play-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "shows",
                  defaultMessage: "\u0936\u094B"
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: shouldShow ? "active" : "",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              href: "/?fatafat=true",
              children: [shouldShow ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "icon-vidos icon-padding",
                src: "https://static.thelallantop.com/images/post/1742905773194_ftafat_(1)-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "icon-vidos icon-padding",
                src: "https://static.thelallantop.com/images/post/1742905597275_ftafat-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                style: {
                  color: shouldShow ? "#D9368B" : "black"
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "fatafat",
                  defaultMessage: "\u0926\u0947\u0916\u093F\u090F"
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: activeTab === "audio" && !shouldShow ? "active" : "",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              href: "/audio",
              onClick: function onClick() {
                if (typeof window.ga !== "undefined") {
                  ga("create", "G-RXRPKR4310", "auto");
                  ga("send", "event", {
                    eventCategory: "bottom_menu",
                    eventAction: "Click",
                    eventLabel: "audio",
                    eventValue: "https://www.thelallantop.com/audio"
                  });
                }

                setActiveTab("audio");
              },
              children: [activeTab === "audio" && !shouldShow ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "icon-listen icon-padding",
                src: "https://static.thelallantop.com/images/post/1742895572359_microphone-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "icon-listen icon-padding",
                src: "https://static.thelallantop.com/images/post/1742894817738_microphone-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "audios",
                  defaultMessage: "\u0938\u0941\u0928\u093F\u090F"
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: activeTab === "short-video" && !shouldShow ? "active" : "",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              onClick: function onClick() {
                if (typeof window.ga !== "undefined") {
                  ga("create", "G-RXRPKR4310", "auto");
                  ga("send", "event", {
                    eventCategory: "bottom_menu",
                    eventAction: "Click",
                    eventLabel: "shorts",
                    eventValue: "https://www.thelallantop.com/short-video"
                  });
                }

                shortsTabClicked();
              },
              children: [activeTab === "short-video" && !shouldShow ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "icon-shows icon-padding",
                src: "https://static.thelallantop.com/images/post/1742895612841_3-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "icon-shows icon-padding",
                src: "https://static.thelallantop.com/images/post/1742894834784_note-2-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "shorts",
                  defaultMessage: "\u0936\u0949\u0930\u094D\u091F\u094D\u0938"
                })
              })]
            })
          })]
        })
      })]
    }), fatafatPosts && fatafatPosts.length > 0 && shouldShow && /*#__PURE__*/(0,jsx_runtime.jsx)(ftafatModal/* default */.Z, {
      show: shouldShow,
      fatafatPosts1: fatafatPosts,
      onClick: function onClick() {
        handleClick();
      },
      queryIndex: queryIndex
    })]
  });
};

/* harmony default export */ var bottomMenu = (MobileMenuBottom);

/***/ })

}]);